import { useEffect, useState } from 'react'
import WhiteButton from '../ApplicationPageComponents/WhiteButton/WhiteButton'
import { Button, Flex, Input, InputNumber, message, Modal, Popconfirm, Radio, TimePicker, Typography } from 'antd'
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons'
import { apiGetSubscribesReport, apiSubscribeReport, apiUnSubscribeReport } from '../../Store/BIReducer/biActions'
import { useDispatch, useSelector } from 'react-redux'
import dayjs from 'dayjs'

const SubscribeToReports = () => {

    const defaultPeriod = {
        type: 'daily',
        day: 1,
    }

    const dispatch = useDispatch()

    const userHash = useSelector(state => state.applications.data.hash);
    const subscribesReports = useSelector(state => state.bi.subscribesReports);

    const [open, setOpen] = useState(false)

    const [emails, setEmails] = useState([])
    const [addingEmail, setAddingEmail] = useState(false)
    const [changesEmailState, setEmailChangesState] = useState({})

    const [periods, setPeriods] = useState([])
    const [currentPeriod, setCurrentPeriod] = useState(defaultPeriod)
    const [addingPeriod, setAddingPeriod] = useState(false)
    const [editingPeriod, setEditingPeriod] = useState(false)

    const closeModal = () => setOpen(false)
    const openModal = () => setOpen(true)

    const addNewEmail = () => {
        setEmails([...emails, { id: Math.random(), value: '', editing: true }])
        setAddingEmail(true)
    }
    const removeEmail = (id) => setEmails(emails.filter(email => email.id !== id))
    const setEditing = (id, editing) => {
        const email = emails.find(email => email.id === id)
        if (!editing && !changesEmailState[email.id]) return message.error('Сначала заполните email')
        setEmails(emails.map(email => email.id === id ? { ...email, editing, value: changesEmailState[email.id] } : email))
        setEmailChangesState({ ...changesEmailState, [id]: email.value })
    }
    const onCancelEmail = (email_id) => {
        const email = emails.find(email => email.id === email_id)
        if (email.value === '') {
            setAddingEmail(false)
            return setEmails(emails.filter(email => email.id !== email_id))
        }
        if (!changesEmailState[email.id]) return message.error('Сначала заполните email')
        setEmails(emails.map(email => email.id === email_id ? { ...email, editing: false } : email))
        setEmailChangesState({ ...changesEmailState, [email_id]: email.value })
        setAddingEmail(false)
    }

    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const onSaveEmail = (email_id) => {
        if (!changesEmailState[email_id]) return message.error('Сначала заполните email')
        const email = emails.find(email => email.id === email_id)
        if (!isValidEmail(changesEmailState[email_id])) return message.error('Некорректный email');
        if (!email) setEmails([...emails, { id: Math.random(), value: changesEmailState[email_id], editing: false }])
        else setEmails(emails.map(email => email.id === email_id ? { ...email, value: changesEmailState[email.id], editing: false } : email))
        setAddingEmail(false)
    }

    const openAdding = () => setAddingPeriod(true)
    const closeAdding = () => setAddingPeriod(false)
    const removePeriod = (id) => setPeriods(periods.filter(period => period.id !== id))
    const editPeriod = (id) => {
        const period = periods.find(period => period.id === id)
        if (!period) return message.error('Период не найден')
        setCurrentPeriod(period)
        setEditingPeriod(true)
    }

    const cancelAddingPeriod = () => {
        closeAdding()
        setCurrentPeriod(defaultPeriod)
    }
    const cancelEditingPeriod = () => {
        setEditingPeriod(false)
        setCurrentPeriod(defaultPeriod)
    }
    const onAddPeriod = () => {
        if (currentPeriod.type === 'weekly' && !currentPeriod.day) return message.error('Выберите день недели')
        if (!currentPeriod.time) return message.error('Выберите время')

        let newPeriod = {}

        newPeriod.id = Math.random()
        newPeriod.type = currentPeriod.type
        newPeriod.day = currentPeriod.day
        newPeriod.time = currentPeriod.time

        setPeriods([...periods, newPeriod])
        addingPeriod ? setAddingPeriod(false) : setEditingPeriod(false)
        setCurrentPeriod(defaultPeriod)
    }
    const onSavePeriod = () => {
        if (currentPeriod.type === 'weekly' && !currentPeriod?.day) return message.error('Выберите день недели')
        if (!currentPeriod?.time) return message.error('Выберите время')
        let newPeriod = {}

        newPeriod.id = currentPeriod.id
        newPeriod.type = currentPeriod.type
        newPeriod.day = currentPeriod.day
        newPeriod.time = currentPeriod.time

        setPeriods(periods.map(period => period.id === currentPeriod.id ? newPeriod : period))
        setEditingPeriod(false)
        setCurrentPeriod(defaultPeriod)
    }

    const onSave = async () => {
        if (emails.length === 0) return message.error('Сначала заполните email')
        if (periods.length === 0) return message.error('Заполните период')

        const emailsList = emails.map(email => email.value)

        await dispatch(apiSubscribeReport({
            data: { emails: emailsList, periods },
            hash: userHash
        }))
        closeModal()
        // resetAll()
    }
    const unSubscribe = async () => {
        await dispatch(apiUnSubscribeReport({ hash: userHash }))
        closeModal()

        resetAll()
    }

    const resetAll = () => {
        setEmails([])
        setPeriods([])
        setCurrentPeriod(defaultPeriod)
        setAddingEmail(false)
        setAddingPeriod(false)
        setEditingPeriod(false)
        setEmailChangesState({})
    }

    const days = {
        1: 'в понедельник',
        2: 'во вторник',
        3: 'в среду',
        4: 'в четверг',
        5: 'в пятницу',
        6: 'в субботу',
        7: 'в воскресенье'
    }

    useEffect(() => {
        dispatch(apiGetSubscribesReport({ hash: userHash }))
    }, [])

    useEffect(() => {
        setEmails(subscribesReports?.emails?.map((email) => ({ id: Math.random(), value: email, editing: false })) || [])
        setPeriods(subscribesReports?.periods?.map((period) => ({ id: Math.random(), type: period.type, day: period.day, time: period.time })) || [])
    }, [subscribesReports])

    return (
        <div style={{ width: '100%' }}>
            <WhiteButton name="Подписка на рассылку отчетности" clicked={openModal} style={{}} />
            <Modal
                open={open}
                onCancel={closeModal}
                onOk={onSave}
                title="Подписка на рассылку отчетности"
                okText="Сохранить"
                cancelButtonProps={{ style: { display: 'none' } }}
                centered
            >
                <Flex vertical gap={20}>
                    <Flex vertical gap={5}>
                        <Typography.Text strong>
                            Получатели
                        </Typography.Text>
                        {
                            emails.map((email, i) => (
                                <Flex key={email.id} gap={5}>
                                    {
                                        email.editing ?

                                            <Input
                                                placeholder='Введите email'
                                                size='small'
                                                value={changesEmailState[email.id]}
                                                onChange={(e) => {
                                                    setEmailChangesState({ ...changesEmailState, [email.id]: e.target.value })
                                                }}
                                            />
                                            :
                                            <Input
                                                placeholder='Введите email'
                                                size='small'
                                                disabled={!email.editing}
                                                value={email.value}
                                                onChange={(e) => {
                                                    setEmails(emails.map((el, index) => {
                                                        if (index === i) return { ...el, value: e.target.value }
                                                        return el
                                                    }))
                                                }}
                                            />
                                    }
                                    {
                                        email.editing ?
                                            (
                                                <Flex gap={5}>
                                                    <Button
                                                        size='small'
                                                        onClick={() => onCancelEmail(email.id)}
                                                    >
                                                        Отмена
                                                    </Button>
                                                    <Button
                                                        danger
                                                        size='small'
                                                        onClick={() => onSaveEmail(email.id)}
                                                    >ОК</Button>
                                                </Flex>
                                            )
                                            :
                                            (
                                                <Flex gap={5}>
                                                    <Button
                                                        icon={<EditOutlined />}
                                                        size='small'
                                                        onClick={() => setEditing(email.id, true)}
                                                    />
                                                    {
                                                        emails.length === 1 ?
                                                            <Popconfirm
                                                                title={<Flex style={{ width: 300 }}>После удаления этого ящика на рассылку больше никто не будет подписан. Подтвердить удаление?</Flex>}
                                                                onConfirm={unSubscribe}
                                                                okText='Да'
                                                                cancelText='Нет'
                                                            >
                                                                <Button
                                                                    icon={<DeleteOutlined />}
                                                                    danger
                                                                    size='small'
                                                                />
                                                            </Popconfirm>
                                                            :
                                                            <Button
                                                                icon={<DeleteOutlined />}
                                                                danger
                                                                size='small'
                                                                onClick={() => removeEmail(email.id)}
                                                            />
                                                    }
                                                </Flex>
                                            )
                                    }
                                </Flex>
                            ))
                        }
                        {
                            !addingEmail ?
                                <Button
                                    size='small'
                                    icon={<PlusOutlined />}
                                    onClick={addNewEmail}
                                >
                                    Добавить получателя
                                </Button>
                                :
                                null
                        }
                    </Flex>
                    <Flex vertical gap={5}>
                        <Typography.Text strong>
                            Период отправки:
                        </Typography.Text>
                        {
                            periods.map((period, i) => {

                                let text = ''
                                text += period.type === 'daily' ? 'Ежедневно' : period.type === 'weekly' ? 'Еженедельно' : 'Ежемесячно'
                                text += ', '
                                text += period.type === 'weekly' ? `${days[period.day]},` : ''
                                text += period.type === 'monthly' ? `${period.day} число,` : ''
                                text += period.time ? ` в ${period.time}` : ''

                                return (
                                    <Flex key={period.id} gap={5}>
                                        <Input
                                            value={text}
                                            disabled
                                            size='small'
                                        />
                                        <Flex gap={5}>
                                            <Button
                                                icon={<EditOutlined />}
                                                size='small'
                                                onClick={() => editPeriod(period.id)}
                                            />
                                            <Button
                                                icon={<DeleteOutlined />}
                                                danger
                                                size='small'
                                                onClick={() => removePeriod(period.id)}
                                            />
                                        </Flex>
                                    </Flex>
                                )
                            })
                        }
                        {
                            !(addingPeriod || editingPeriod) ?
                                <Button
                                    size='small'
                                    icon={<PlusOutlined />}
                                    onClick={openAdding}
                                >
                                    Добавить период
                                </Button>
                                :
                                <Flex vertical gap={10}>
                                    <Radio.Group
                                        onChange={(e) => setCurrentPeriod({ ...currentPeriod, type: e.target.value })}
                                        value={currentPeriod?.type}
                                    >
                                        <Radio value="daily">Ежедневно</Radio>
                                        <Radio value="weekly">Еженедельно</Radio>
                                        <Radio value="monthly">Ежемесячно</Radio>
                                    </Radio.Group>

                                    {
                                        currentPeriod?.type === 'weekly' ?
                                            <>
                                                <Typography.Text>
                                                    Повторять каждый следующий день:
                                                </Typography.Text>

                                                <Radio.Group
                                                    options={[
                                                        { label: 'Понедельник', value: '1', style: { width: 120 } },
                                                        { label: 'Вторник', value: '2', style: { width: 100 } },
                                                        { label: 'Среда', value: '3', style: { width: 100 } },
                                                        { label: 'Четверг', value: '4', style: { width: 120 } },
                                                        { label: 'Пятница', value: '5', style: { width: 120 } },
                                                        { label: 'Суббота', value: '6', style: { width: 100 } },
                                                        { label: 'Воскресенье', value: '7', style: { width: 100 } }
                                                    ]}
                                                    onChange={(e) => setCurrentPeriod({ ...currentPeriod, day: e.target.value })}
                                                    value={currentPeriod?.day}
                                                ></Radio.Group>
                                            </>
                                            :
                                            null
                                    }
                                    {
                                        currentPeriod?.type === 'monthly' ?
                                            <Flex gap={10}>
                                                <Typography.Text>
                                                    Повторять каждое
                                                </Typography.Text>
                                                <InputNumber
                                                    controls={false}
                                                    size='small'
                                                    style={{ width: '30px' }}
                                                    min={1}
                                                    max={31}
                                                    value={currentPeriod?.day}
                                                    onChange={(value) => setCurrentPeriod({ ...currentPeriod, day: value })}
                                                />
                                                <Typography.Text>
                                                    число месяца
                                                </Typography.Text>
                                            </Flex>
                                            :
                                            null
                                    }
                                    <Flex gap={10}>
                                        <Typography.Text>В данное время:</Typography.Text>
                                        <TimePicker
                                            size='small'
                                            placeholder='Время'
                                            format={'HH:mm'}
                                            onOk={(date) => setCurrentPeriod({ ...currentPeriod, time: date.format('HH:mm') })}
                                            onChange={(_, timeString) => setCurrentPeriod({ ...currentPeriod, time: timeString })}
                                            value={currentPeriod?.time ? dayjs(currentPeriod?.time, 'HH:mm') : null}
                                            showNow={false}
                                        />
                                    </Flex>
                                    <Flex gap={10} justify='end'>
                                        <Button
                                            size='small'
                                            onClick={addingPeriod ? cancelAddingPeriod : cancelEditingPeriod}
                                        >
                                            Отмена
                                        </Button>
                                        <Button
                                            danger
                                            size='small'
                                            onClick={addingPeriod ? onAddPeriod : onSavePeriod}
                                        >
                                            ОК
                                        </Button>
                                    </Flex>
                                </Flex>
                        }
                        <Typography.Text type='secondary'>
                            Примечание: Отчет отправляется по завершенным и отмененным заявкам. Отчет не отправляется при отсутствии заявок за выбранный период.
                        </Typography.Text>
                    </Flex>
                </Flex>
            </Modal>

        </div >
    )
}

export default SubscribeToReports